<template>
  <div class="row">
    <div class="col-xs-12">
      <h4>Total de agendamentos</h4>
    </div>
    <div class="col-xs-12 chartBarWrapper">
      <BarChart
        :chartData="chartData"
        :gradiente="false"
        :options="options"
      ></BarChart>
    </div>
  </div>
</template>

<script>
import { BarChart } from '../common'
import { request } from '../../request'
import colors from '../../utils/colors'

export default {
  components: {
    BarChart
  },
  data() {
    return {
      especialidades: Array(),
      exames: Array(),
      options: {
        responsive: true,
        maintainAspectRatio: false,
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return Number(tooltipItem.yLabel).toLocaleString()
            }
          }
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function(label, index, labels) {
                  return Number(label).toLocaleString()
                }
              }
            }
          ]
        }
      }
    }
  },
  mounted() {
    this.fetchAgendados()
  },
  methods: {
    fetchAgendados() {
      request
        .get('/procedimentos-saude/especialidades/total-agendados')
        .then(response => {
          this.especialidades = response.data
        })
        .catch(error => {
          console.log(error.response)
        })

      request
        .get('/procedimentos-saude/exames/total-agendados')
        .then(response => {
          this.exames = response.data
        })
        .catch(error => {
          console.log(error.response)
        })
    }
  },
  computed: {
    chartData() {
      const labels = this.especialidades.map(item => {
        const dataAtual = new Date(`${item.mesano}-01 00:00`)
        return `${_.startCase(
          dataAtual.toLocaleString('default', {
            month: 'short'
          })
        )} / ${dataAtual
          .getFullYear()
          .toString()
          .substring(2)}`
      })

      const datasets = [
        {
          label: 'Especialidades',
          data: this.especialidades.map(item => item.total),
          backgroundColor: colors.coresHexa[0]
        },
        {
          label: 'Exames',
          data: this.exames.map(item => item.total),
          backgroundColor: colors.coresHexa[1]
        }
      ]
      return {
        labels,
        datasets
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProcedimentosSaude/EstatisticaTotalAgendamentos.vue